import { render, staticRenderFns } from "./GerarRelatoriosClientes.vue?vue&type=template&id=aa06c0ee&scoped=true&"
import script from "./GerarRelatoriosClientes.vue?vue&type=script&lang=js&"
export * from "./GerarRelatoriosClientes.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatoriosClientes.vue?vue&type=style&index=0&id=aa06c0ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa06c0ee",
  null
  
)

export default component.exports